import React from "react";
import { Heart } from "lucide-react";
import { InteractPrompt } from "@/components/game/InteractPrompt";

const SPRITE = {
  slate: "/school/obj/slate.png",
  bell: "/school/obj/bell.png",
  bag: "/school/obj/bag.png",
  tiffin: "/school/obj/tiffin.png",
  notebook: "/school/obj/notebook.png",
  globe: "/school/obj/globe.png",
};

// A classroom object drawn in-world, tagged with a pinned ruled-notebook-paper chit.
export const SchoolObject = ({ zone, active, unlocked, onClick }) => {
  const src = SPRITE[zone.sprite];
  return (
    <div className="absolute z-20" style={{ left: `${zone.x}%`, top: `${zone.y}%`, transform: "translate(-50%,-50%)" }}>
      {active && <InteractPrompt />}
      <button
        data-testid={`zone-${zone.id}`}
        onClick={onClick}
        className={`group relative flex flex-col items-center transition-transform duration-150 hover:scale-[1.05] ${active ? "scale-[1.05] z-30" : ""}`}
      >
        {/* the illustrated object */}
        <img
          src={src}
          alt={zone.label}
          draggable={false}
          className={`h-[62px] w-auto max-w-[92px] select-none object-contain transition-[filter] duration-200 sm:h-[80px] ${active ? "drop-shadow-[0_0_12px_rgba(255,209,102,0.95)]" : "drop-shadow-[0_4px_4px_rgba(0,0,0,0.35)]"}`}
        />
        <span className="-mt-1 h-2 w-12 rounded-[50%] bg-black/25 blur-[2px]" />

        {/* pinned ruled-paper name chit (school style) */}
        <div
          className="relative mt-0.5 -rotate-1 rounded-[2px] px-2 pb-0.5 pt-1 shadow-[2px_3px_0_rgba(0,0,0,0.28)]"
          style={{ backgroundImage: "repeating-linear-gradient(#fbf6e9 0 9px,#e2ecf3 9px 10px)", border: "1px solid #cbb98f" }}
        >
          <span className="absolute -top-1.5 left-1/2 h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-[#c1121f] shadow-[0_1px_1px_rgba(0,0,0,0.45)] ring-1 ring-white/70" />
          <span className="font-signboard block max-w-[100px] text-center text-[11px] font-bold leading-tight text-[#2b3a67]">{zone.label}</span>
          <span className="block text-center text-[8px] font-semibold leading-none text-[#7a5230]">{zone.sub}</span>
        </div>

        {unlocked && (
          <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-cream">
            <Heart className="h-3 w-3 fill-kirana-red text-kirana-red" />
          </span>
        )}
      </button>
    </div>
  );
};
